import React, { useEffect } from "react";
import { Legend, ResponsiveContainer, Tooltip, CartesianGrid, BarChart, XAxis, YAxis, Bar } from "recharts";
import { Select } from "uxp/components";
import { distinct } from "@utils";
import { IPreviewProps } from "@types";
import './styles.scss';

export const BarChartPreview: React.FunctionComponent<IPreviewProps> = (props) => {
    const [valueField, setValueField] = React.useState('');
    const [labelField, setLabelField] = React.useState('');
    const [groupField, setGroupField] = React.useState('');
    const type = 'pie';
    const chartSize = 80;
    const colors = [
        '#669FEC',
        '#5652C2',
        '#BC59C3',
        '#BB597B',
        '#72C1C7',
        '#ABE087',
        '#C76663',
    ];
    function getTooltipText(item: any) {
        if (groupField) {
            return `${item?.[groupField]} - ${item?.[labelField || 'name']} : ${(item?.[valueField || 'value'])}`
        }
        return `${item?.[labelField || 'name']} : ${(item?.[valueField || 'value'])}`

    }
    let schema = props.schema || [];
    useEffect(() => {
        if (props.schema && !valueField) {
            let item = schema.find((x) => x.type == 'number');
            if (item) {
                setValueField(item.name);
            }
        }
        if (schema && !labelField) {

            let item = schema.find((x) => x.type == 'string');
            console.log('IMTEIZE', item, schema);
            if (item) {
                setLabelField(item.name);
            }

        }
    }, [props.schema]);
    let numericFields = schema.filter((x) => x.type == 'number');
    if (numericFields.length == 0) {
        numericFields = schema;
    }
    let transformedData = props.data?.map((x: any) => {
        var y = { ...x };
        y[valueField] = Number(y[valueField]);
        return y;
    });
    let chartGroups = [{ data: transformedData, color: colors[0] }];
    if (groupField) {
        let groups = distinct(props.data, groupField);
        if (groups.length > 1) {
            let i = 0;
            chartGroups = [];
            for (let group of groups) {
                let groupData = props.data.filter((x: any) => x[groupField]?.toLowerCase?.() == group?.toLowerCase?.());
                chartGroups.push({
                    data: groupData,
                    color: colors[i % colors.length],
                });
                i++;
            }
        }

    }
    return <div className='qe-preview-pie-chart'>
        <div className='qe-preview-chart-props'>

            <label>Y-Axis</label>
            <Select renderOption={(option, key) => <div className={'qe-chart-select-option ' + (option.type == 'number' ? '' : 'disabled')}>{option.name}</div>} className="lucy-query-engine-input" onChange={setValueField} options={schema} labelField="name"
                valueField="name" selected={valueField} />

            <label>X-Axis</label>
            <Select
                renderOption={(option, key) => <div className={'qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled')}>{option.name}</div>}
                className="lucy-query-engine-input" onChange={setLabelField} options={schema} labelField="name"
                valueField="name" selected={labelField} />
            <label>Group By</label>
            <Select
                renderOption={(option, key) => <div className={'qe-chart-select-option ' + (option.type == 'string' ? '' : 'disabled')}>{option.name}</div>}
                className="lucy-query-engine-input" onChange={setGroupField} options={schema} labelField="name"
                valueField="name" selected={groupField} />


        </div>
        <div className='qe-preview' style={{ maxWidth: '800px' }}>
            {
                (valueField && labelField) ?
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                            //   width={500}
                            //   height={300}
                            data={props.data?.map((x: any) => {
                                var y = { ...x };
                                y[valueField] = Number(y[valueField]);
                                return y;
                            })}
                            margin={{
                                top: 10,
                                right: 10,
                                left: 10,
                                bottom: 10,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey={labelField} />
                            <YAxis />
                            <Tooltip content={(props) => {
                                return <div className='wd-chart-tooltip'>
                                    <div className="label">{getTooltipText(props?.payload?.[0]?.payload)}</div>
                                </div>
                            }} />
                            {<Legend formatter={(v, e, i) => props.data?.[i]?.[labelField || 'name'] || 'Unknown'} />}


                            {
                                chartGroups.map((group, i) => <Bar dataKey={valueField} stackId={'g' + i} fill={group.color} data={group.data} />)
                            }

                        </BarChart>
                    </ResponsiveContainer>
                    : <div className='pie-chart-info'>Select a field to plot</div>
            }

        </div>
    </div>
}
